/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckLegalInformationRequest
 */
export interface CheckLegalInformationRequest {
    /**
     * 
     * @type {string}
     * @memberof CheckLegalInformationRequest
     */
    clientCompanyId: string;
}

/**
 * Check if a given object implements the CheckLegalInformationRequest interface.
 */
export function instanceOfCheckLegalInformationRequest(value: object): value is CheckLegalInformationRequest {
    if (!('clientCompanyId' in value) || value['clientCompanyId'] === undefined) return false;
    return true;
}

export function CheckLegalInformationRequestFromJSON(json: any): CheckLegalInformationRequest {
    return CheckLegalInformationRequestFromJSONTyped(json, false);
}

export function CheckLegalInformationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckLegalInformationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientCompanyId': json['clientCompanyId'],
    };
}

export function CheckLegalInformationRequestToJSON(value?: CheckLegalInformationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientCompanyId': value['clientCompanyId'],
    };
}

